import { PasswordModal } from '@/scripts/optional/password-modal'
import { TsDOM as q} from '@/scripts/core/TsDOM'
q.safeDefineElement(PasswordModal)
